import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { resolveHomePath } from '../utils/navigation';

const parseTokenPayload = (token) => {
  if (!token) return null;
  try {
    const payloadBase64 = token.split('.')[1];
    if (!payloadBase64) return null;
    const decoded = atob(payloadBase64);
    return JSON.parse(decoded);
  } catch (error) {
    console.error('Failed to parse auth token:', error);
    return null;
  }
};

const isTokenExpired = (payload) =>
  typeof payload?.exp === 'number' && payload.exp * 1000 <= Date.now();

const clearInvalidToken = () => {
  localStorage.removeItem('authToken');
};

const ProtectedRoute = ({ children, allowedRoles }) => {
  const location = useLocation();
  const token = localStorage.getItem('authToken');

  if (!token) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  const payload = parseTokenPayload(token);
  const homePath = resolveHomePath(payload?.userType);

  if (!payload || isTokenExpired(payload) || homePath === '/') {
    clearInvalidToken();
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(payload.userType)) {
    return <Navigate to={homePath} replace />;
  }

  return children;
};

export const GuestRoute = ({ children }) => {
  const token = localStorage.getItem('authToken');
  if (!token) {
    return children;
  }

  const payload = parseTokenPayload(token);
  if (!payload || isTokenExpired(payload)) {
    clearInvalidToken();
    return children;
  }

  const homePath = resolveHomePath(payload?.userType);
  if (homePath === '/') {
    clearInvalidToken();
    return children;
  }

  return <Navigate to={homePath} replace />;
};

export default ProtectedRoute;
